// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"94ee331c","703":"007b74cc","787":"5ede6396"}[chunkId] + ".chunk.js";
};